import Http from '@/services/httpAcademy'

export const listRefundRequests = (params) =>
	Http.get('/admin/refund-requests', { params })

export const approveRefundRequest = (id, data) =>
	Http.patch(`/admin/refund-requests/${id}/approve`, data)

export const rejectRefundRequest = (id, data) =>
	Http.patch(`/admin/refund-requests/${id}/reject`, data)
